import "./index.scss"

export const HomePage = () => {

    return (<div className="main-container">
        <h1>React Gamification Demos</h1>
        <p>This site hopes to provide some resources for mastering React.  All of the game demos shown here are just 
            the tip of the iceberg. They're made entirely of React components 
            and don't rely on the Canvas object or WebGL. They may seem cheesy and deceptively simple 
            but they make it possible to illustrate complex concepts such as auto-updating components that make use of reactive state to create self-referential update loops. Thanks to <a href="kenney.nl">kenney.nl</a> for making his graphics public domain.  </p>
        <p>I employ a non-conventional game-based approach to learning new frameworks, and I hope that you can benefit from the same approach. With regard to the CSS for these components, I used a variety of approaches: CSS modules, styled-components, and SASS.</p>
        
        <p>I'm a developer with a background in game development and currently specializing in front-end development. Contact me <a href="mailto:mack64948@gmail.com">by email</a>.  This website is not yet responsive.  Please view it in the desktop layout. </p>
        <p>Here is the link to a very old (and outdated) site I made with Bootstrap with information about game apps that I had published in the Apple AppStore: <a href="https://suzhoupanda.github.io">iOS Panda Developers</a>. Here is a link to my Book Review site made with Next.js: <a href="https://book-review-site.vercel.app">Amazing Book Reviews</a></p>
        <cite style={{
            textAlign: "right",
            width: "100%"}}>
            Alex Makedonski
        </cite>
    </div>)
}
